import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import InputField from '../../shared/form-elements/input';
import LangSwitch from '../../shared/lang/switch';

const Form = ({
	handleSubmit,
	updateTranslations,
	mainTabLangs,
	switchLanguage,
	intl,
	can
}) =>
	<div className="form-container">
		<div className="form-container__head">
			<h2>
				{intl('Edit payout system')}
			</h2>
		</div>

		<div className="form-container__body">
			<LangSwitch langs={mainTabLangs} onChangeLang={switchLanguage}/>
			<form
				className="ui-form create-payoutSystem"
				onSubmit={handleSubmit(data => updateTranslations(data))}
			>

				<div className="ui-form__element">
					<Field name="title" placeholder={intl('Title')} component={InputField} />
				</div>

				<div className="ui-form__element">
					{can('edit') &&
						<button className="ui-btn ui-btn-primary">
							{intl('Edit')}
						</button>}
					<Link to="payout-systems/">
						<button className="ui-btn ui-btn-cancel">
							{intl('Cancel')}
						</button>
					</Link>
				</div>
			</form>
		</div>
	</div>;

Form.propTypes = {
	handleSubmit: PropTypes.func,
	updateTranslations: PropTypes.func,
	mainTabLangs: PropTypes.array,
	switchLanguage: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func
};

export default reduxForm({
	form: 'payoutSystemsForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-systems/components/form-translations.js